import { Countries } from "types/Models/countries";
import { SUGGESTED_COUNTRIES } from "constants/countryCodes";

export const getIsStateRequired = (
  countries: Countries[] | undefined,
  countryName: string
) => countries?.find((c) => c.name === countryName)?.state_required ?? false;

export const getIsStateRequiredByUuid = (
  countries: Countries[] | undefined,
  countryUuid: string
) => countries?.find((c) => c.uuid === countryUuid)?.state_required ?? false;

export const getSuggestedCountryOptions = (
  countries: Countries[] | undefined
) =>
  SUGGESTED_COUNTRIES.flatMap((name) => {
    if (!countries?.some((c) => c.name === name)) return [];
    return [{ label: name, value: name }];
  });

export const getGroupedCountryOptionsByName = (
  countries: Countries[] | undefined
) => [
  { label: "Suggested", options: getSuggestedCountryOptions(countries) },
  {
    label: "All countries",
    options: (countries || []).map((c) => ({ label: c.name, value: c.name })),
  },
];

export const getGroupedCountryOptionsByUuid = (
  countries: Countries[] | undefined
) => [
  {
    label: "Suggested",
    options: SUGGESTED_COUNTRIES.flatMap((name) => {
      const match = countries?.find((c) => c.name === name);
      if (!match) return [];
      return [{ label: match.name, value: match.uuid }];
    }),
  },
  {
    label: "All countries",
    options: (countries || []).map((c) => ({ label: c.name, value: c.uuid })),
  },
];

export const findOptionInGroups = (
  groups: { label: string; options: { label: string; value: string }[] }[],
  value: string | undefined | null
) => {
  if (!value) return null;
  for (const group of groups) {
    const match = group.options.find((option) => option.value === value);
    if (match) return match;
  }
  return null;
};
